module.exports = __webpack_public_path__ + "static/prodinity_vertical_logo-9b934eb03461080a8893c1050b0d8b5a.svg";